export const IS_OPEN = '@modal/IS_OPEN';
export type OPEN = typeof IS_OPEN;

export interface SetIsOpen {
  type: OPEN;
  payload: {
    isOpen: false,
  }
}

export function setIsOpen(isOpen: any): SetIsOpen {
  return {
    type: IS_OPEN,
    payload: {
      isOpen: isOpen
    }
  };
}